import React from "react";
import ModalShell from "./ModalShell";
import TeeDot from "../TeeDot";
import { Tee } from "../types";

interface Props {
  tees: Tee[];
  // Highlights the currently active tee (player 1's tee, or the manual
  // Yds-row override). Tapping any row swaps to that tee and closes the
  // modal — the parent decides whether to persist that as the display
  // override.
  selectedId?: string;
  onSelect: (teeId: string) => void;
  onClose: () => void;
}

function teeTotalYards(tee: Tee): number | null {
  if (!tee.yardages || tee.yardages.length === 0) return null;
  return tee.yardages.reduce((s, y) => s + (y || 0), 0);
}

export default function TeesModal({
  tees,
  selectedId,
  onSelect,
  onClose,
}: Props) {
  return (
    <ModalShell title="Tees" onClose={onClose}>
      {tees.length === 0 ? (
        <p className="cg-modal-note">No tees configured for this course.</p>
      ) : (
        <ul className="cg-tee-list">
          {tees.map((t) => {
            const total = teeTotalYards(t);
            const active = t.id === selectedId;
            return (
              <li
                key={t.id}
                className={`cg-tee-row${active ? " cg-tee-row-active" : ""}`}
                onClick={() => onSelect(t.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") onSelect(t.id);
                }}
              >
                <TeeDot tee={t} size={18} />
                <div className="cg-tee-info">
                  <div className="cg-tee-name">{t.name}</div>
                  <div className="cg-tee-meta">
                    {total != null && <span>{total.toLocaleString()} yds</span>}
                    {t.rating != null && <span>Rating {t.rating}</span>}
                    {t.slope != null && <span>Slope {t.slope}</span>}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </ModalShell>
  );
}
